import React, { useCallback, useState } from "react"
import Unity, { UnityContext } from "react-unity-webgl"

const unityContext = new UnityContext({
  loaderUrl:
    "https://tools.vrtinnovatie.be/EDUbox/games/space/assets/space.v2.loader.js",
  dataUrl:
    "https://tools.vrtinnovatie.be/EDUbox/games/space/assets/space.v2.data",
  frameworkUrl:
    "https://tools.vrtinnovatie.be/EDUbox/games/space/assets/space.v2.framework.js",
  codeUrl:
    "https://tools.vrtinnovatie.be/EDUbox/games/space/assets/space.v2.wasm",
})

const HostMinigame = () => {
  const [didError, setDidError] = useState(false)
  const [minigameLevel, setMinigameLevel] = useState(1)

  const onGameLoaded = useCallback(() => {
    console.log("game loaded:", minigameLevel)
    unityContext.send("GameHandler", "SetLevel", minigameLevel)
  }, [minigameLevel])

  React.useEffect(() => {
    console.log("HostMinigame component mounted")
    console.log("UnityContext:", unityContext)
  }, [unityContext])

  React.useEffect(() => {
    unityContext.send("Player", "Control", undefined)
    unityContext.send("GameHandler", "SetLevel", 1)
    setMinigameLevel(1)
  }, [])

  React.useEffect(() => {
    unityContext.on("UpdateScore", function (score) {
      console.log("Score updated:", score)
    })
    unityContext.on("error", function () {
      setDidError(true)
    })
    unityContext.on("debug", function (message) {
      console.log("Unity debug:", message)
    })
    // eslint-disable-next-line
  }, [])

  React.useEffect(() => {
    unityContext.on("loaded", function () {
      onGameLoaded()
    })
  }, [onGameLoaded])

  if (didError) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h1>Er ging iets mis met de space game</h1>
        <p>Probeer het later opnieuw.</p>
      </div>
    )
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#000",
      }}
    >
      <div>
        <Unity
          unityContext={unityContext}
          style={{
            height: "100%",
            width: 814,
            border: "2px solid black",
            background: "grey",
          }}
        />
      </div>
    </div>
  )
}

export default HostMinigame
